const BikeComparatorEmptyItem = () => (
  <div className="bike-comparator-item bike-comparator-item--empty">
    <i className="icon icon-bike"></i>
  </div>
);

export default BikeComparatorEmptyItem;
